import useFeatureFlags from "../../hooks/useFeatureFlags";
import useTestData from "../../hooks/useTestData";
import { formatDate } from "../../utils";
import Loader from "../AppLoader";
import { GENDER_TEXTS } from "../data-input-forms/BasicPersonalDataForm";

export default function QuickView() {
    const { value, loading, error } = useTestData();
    const { featureFlags } = useFeatureFlags();

    if (loading)
        return (
            <Loader containerClassName="h-[156px] w-leftSidebar shrink-0 grid place-items-center" />
        );

    if (error || !value) return <div>Error Getting Data</div>;

    const { testDate, firstName, lastName, gender, age, weight, height } =
        value;

    // Parse height for display - converts inches to feet and inches (85 inches = 7 feet 1 inch)
    const getHeightDisplay = () => {
        if (featureFlags?.foot_pound) {
            const feet = Math.floor(height / 12);
            const inches = height % 12;
            const inchesRounded = Math.round(inches * 10) / 10; // Round to 1 decimal place
            return `${feet} ft${inchesRounded > 0 ? ` ${inchesRounded} in` : ""}`;
        }
        return `${height} cm`;
    };

    const quickViewData = [
        {
            label: "Full Name",
            value: `${firstName} ${lastName}`,
        },
        {
            label: "Test Date",
            value: formatDate(new Date(testDate)),
        },
        {
            label: "Gender",
            value: GENDER_TEXTS[gender],
        },
        {
            label: "Age",
            value: age,
        },
        {
            label: "Weight",
            value: `${weight} ${featureFlags?.foot_pound ? "lb" : "kg"}`,
        },
        {
            label: "Height",
            value: getHeightDisplay(),
        },
    ];

    return (
        <div className="mr-0">
            {quickViewData.map(({ label, value }) => (
                <div
                    key={label}
                    className="flex text-xs xl:text-sm xl:h-[26px]"
                >
                    <span className="shrink-0 font-bold w-[70px] xl:w-[79px] pe-1 leading-[1.8] xl:leading-9">
                        {label}:{" "}
                    </span>
                    <span className="font-semibold leading-[1.8] xl:leading-9 truncate">
                        {value}
                    </span>
                </div>
            ))}
        </div>
    );
}
